var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnEtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#4A7FF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 16.85V7.64H9.77V16.85H11.1ZM8.36 8.6H3.94V9.65H7.01C6.82 11.69 5.8 13.14 3.45 14.26L4.14 15.3C7.41 13.73 8.36 11.41 8.36 8.6ZM19.3392 12.23H20.6792V11.14H19.3392V7.65H18.0192V16.87H19.3392V12.23ZM13.8092 13.72V12.01H16.6892V10.98H13.8092V9.48H16.8192V8.41H12.4892V14.78H13.2692C14.8692 14.78 16.0792 14.74 17.4892 14.53L17.3692 13.48C16.1692 13.67 15.0992 13.72 13.8092 13.72Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEtc);
export default __webpack_public_path__ + "static/media/btnEtc.4a640f5557e3f8d17e1b6963bc5b0473.svg";
export { ForwardRef as ReactComponent };